import { useEffect, useState } from 'react'
import { parseTaskCategories, TaskCategory } from '../model/categoryNames'

export const TASK_CATEGORIES_STORAGE_KEY = 'task_categories_session'
export const CATEGORIES_UPDATE_EVENT = 'task_categories_updated'
export function loadCategoriesFromStorage(): TaskCategory[] {
  try {
    return parseTaskCategories(JSON.parse(localStorage.getItem(TASK_CATEGORIES_STORAGE_KEY) || '[]'))
  } catch {
    return []
  }
}
export function saveCategoriesToStorage(categories: TaskCategory[]) {
  const normalized = parseTaskCategories(categories)

  try {
    localStorage.setItem(TASK_CATEGORIES_STORAGE_KEY, JSON.stringify(normalized))
  } catch {
    /* session remains usable */
  }
  window.dispatchEvent(new CustomEvent(CATEGORIES_UPDATE_EVENT, { detail: normalized }))
}
export function clearTaskCategoriesFromStorage() {
  try {
    localStorage.removeItem(TASK_CATEGORIES_STORAGE_KEY)
  } catch {
    /* session remains usable */
  }
  window.dispatchEvent(new CustomEvent(CATEGORIES_UPDATE_EVENT, { detail: [] }))
}
/** One storage/event contract for modal, flat-list and grouped-page category controls. */
export function useTaskCategories() {
  const [categories, setCategories] = useState(loadCategoriesFromStorage)

  useEffect(() => {
    // Earlier sibling effects may have published a restored category before this subscription mounted.
    setCategories(loadCategoriesFromStorage())

    const onUpdate = (event: Event) => setCategories(parseTaskCategories((event as CustomEvent).detail))

    const onStorage = (event: StorageEvent) => {
      if (event.key === TASK_CATEGORIES_STORAGE_KEY || event.key === null) setCategories(loadCategoriesFromStorage())
    }

    window.addEventListener(CATEGORIES_UPDATE_EVENT, onUpdate)
    window.addEventListener('storage', onStorage)
    return () => {
      window.removeEventListener(CATEGORIES_UPDATE_EVENT, onUpdate)
      window.removeEventListener('storage', onStorage)
    }
  }, [])

  return { categories, setCategories, saveCategories: saveCategoriesToStorage }
}
